import { Link } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { clsBouton } from './partages';
import { Familles } from './Home';

/** 404 — utile, pas mignonne. On renvoie vers ce qui se vend. */
export function Introuvable() {
  return (
    <main id="contenu" className="mx-auto max-w-[1080px] px-5 py-16 sm:px-6">
      <div className="max-w-xl">
        <p className="eyebrow flex items-center gap-2"><Icon name="knife" size={15} /> Page introuvable</p>
        <h1 className="mt-3 text-balance text-[clamp(2.2rem,5vw,3.4rem)] leading-[1.03]">
          Cette page est partie<br /><span className="italic text-wine">à la découpe.</span>
        </h1>
        <p className="mt-4 text-[1.0625rem] leading-relaxed text-ink-soft">
          Le lien est peut-être ancien. En attendant, voici les dix familles du comptoir —
          ou la recherche, si vous savez déjà ce que vous cherchez.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link to="/" className={clsBouton('primary')}>Retour à l’accueil</Link>
          <Link to="/boutique" className={clsBouton('outline')}>Tout le comptoir</Link>
        </div>
      </div>

      <div className="mt-14">
        <Familles />
      </div>
    </main>
  );
}
